import { useEffect, useState } from 'react';
import { Link, NavLink, Route, Routes, useParams } from 'react-router-dom';
import css from './CourseDetails.module.css';

import * as courseServices from '../../../../../services/courseServices';
import * as enrollServices from '../../../../../services/enrollServices';

import ModalForm from '../../../_common/ModalForm';
import AddNewCourse from '../overview/AddNewCourse';
import DownloadAttList from './DownloadAttList';
import CourseSchedule from '../schedule/CourseSchedule';
import CourseAbsence from '../_obs/CourseAbsence';
import RollbackButton from '../../../_common/elements/RollbackButton';
import ViewCertificateButton from '../../../_common/elements/ViewCertificateButton';
import CDGeneral from './CDGeneral';
import MailToAll from './MailToAll';
import Tabs from '../../../../00_app/Tabs';
import StudentList from '../student-list/StudentList';
import CourseAttendance from '../attendance/CourseAttendance';

function CourseDetails() {
    const { courseId } = useParams();
    const [courseDetails, setCourseDetails] = useState([{ courseId }]);
    const [showModal, setShowModal] = useState(false);
    const [message, setMessage] = useState('');
    const [render, setRender] = useState(0);

    useEffect(() => {
        courseServices
            .getById(courseId)
            .then((result) => {
                result.data = result.data.sort((a, b) => a.studentName.localeCompare(b.studentName));
                setCourseDetails((state) => result.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [courseId, render]);

    // const rollbackHandle = (requestId) => {
    //     console.log(requestId);
    // };
    // const showCertificate = (certificateref) => {
    //     console.log(certificateref);
    // };

    const onConfirmRollback = (enrollId) => {
        enrollServices
            .del({ _id: enrollId })
            .then((result) => {
                setCourseDetails(courseDetails.filter((x) => x.enrollId !== enrollId));
                console.log(result.message);
            })
            .catch((error) => {
                console.log(error.message);
            });
    };

    const attHandle = (e) => {
        // console.log(e.currentTarget.checked);
        // console.log(e.currentTarget.name);

        const _id = Number(e.currentTarget.id);
        const value = e.currentTarget.checked ? 1 : 0;
        const attribute = e.currentTarget.name;

        let updatedArr = courseDetails.map((el) => {
            if (el.enrollId === _id) {
                el[attribute] = value;
            }

            return el;
        });
        enrollServices
            .edit({
                _id: _id,
                isAtt: attribute === 'isAtt' ? value : courseDetails.filter((a) => a.enrollId === _id)[0].isAtt,
                isPass: attribute === 'isPass' ? value : courseDetails.filter((a) => a.enrollId === _id)[0].isPass,
            })
            .then((result) => {
                setCourseDetails(updatedArr);
                setMessage((message) => result.message);

                setTimeout(() => {
                    setMessage((message) => '');
                }, 1000);
                // console.log(result.message);
            })
            .catch((error) => {
                console.log(error.message);
            });
    };

    //Open and close the input form
    const toggleModal = () => setShowModal(!showModal);

    const onAdd = (data) => {
        setRender((s) => ++s);
    };
    // console.log(courseDetails);

    return (
        <div>
            <h1 className={css.h1}>{`(${courseDetails[0]?.courseNo}) ${courseDetails[0]?.courseTitle}`}</h1>
            {/* <div>
                <NavLink to={`/course/attendance/${courseDetails[0].courseId}`}>Attendance</NavLink>
            </div> */}
            <CDGeneral data={courseDetails[0]} toggleModal={toggleModal} />

            <Tabs
                tabs={[
                    { to: `/course/details/${courseDetails[0].courseId}/student_list`, title: 'Students' },
                    { to: `/course/details/${courseDetails[0].courseId}/attendance`, title: 'Attendance' },
                    { to: `/course/details/${courseDetails[0].courseId}/exam`, title: 'Exams' },
                    { to: `/course/details/${courseDetails[0].courseId}/schedule`, title: 'Schedule' },
                ]}
            />
            <Routes>
                <Route
                    path="student_list"
                    element=<StudentList
                        courseDetails={courseDetails}
                        setCourseDetails={setCourseDetails}
                        message={message}
                        setMessage={setMessage}
                    />
                />
                <Route path="attendance" element=<CourseAttendance courseDetails={courseDetails} /> />
                <Route path="schedule" element=<CourseSchedule courseDetails={courseDetails} /> />
            </Routes>

            
            <ModalForm showModal={showModal}>
                <AddNewCourse data={courseDetails[0]} onAdd={onAdd} toggleModal={toggleModal} func={'edit'} />
            </ModalForm>
        </div>
    );
}

export default CourseDetails;
